import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const CONSENT_KEY = 'mrminds_cookie_consent';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(CONSENT_KEY);
    if (!saved) {
      setVisible(true);
      return;
    }
    if (saved === 'granted' && window.__grantAnalytics) {
      window.__grantAnalytics();
    }
  }, []);

  const accept = () => {
    localStorage.setItem(CONSENT_KEY, 'granted');
    if (window.__grantAnalytics) window.__grantAnalytics();
    setVisible(false);
  };

  const reject = () => {
    localStorage.setItem(CONSENT_KEY, 'denied');
    if (window.__denyAnalytics) window.__denyAnalytics();
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: 24,
      left: 24,
      zIndex: 9999,
      width: 300,
      background: '#111827',
      border: '1px solid rgba(255,255,255,0.1)',
      borderRadius: 16,
      padding: '20px',
      boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
      animation: 'slideUp 0.3s ease',
    }}>
      <style>{`
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(16px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>

      {/* Cookie icon */}
      <div style={{ fontSize: 32, marginBottom: 12, lineHeight: 1 }}>🍪</div>

      {/* Title */}
      <p style={{ color: '#ffffff', fontSize: 14, fontWeight: 700, margin: '0 0 6px 0' }}>
        Ta strona używa cookies
      </p>

      {/* Description */}
      <p style={{ color: '#9CA3AF', fontSize: 12, margin: '0 0 16px 0', lineHeight: 1.6 }}>
        Używamy plików cookie do analizy ruchu (Google Analytics) i marketingu (Meta Pixel).{' '}
        <Link to="/dokument/polityka-cookies" style={{ color: '#10b981', textDecoration: 'none' }}>
          Dowiedz się więcej
        </Link>
      </p>

      {/* Buttons */}
      <div style={{ display: 'flex', gap: 8 }}>
        <button
          onClick={reject}
          style={{
            flex: 1,
            background: 'transparent',
            border: '1px solid rgba(255,255,255,0.12)',
            color: '#9CA3AF',
            fontSize: 12,
            fontWeight: 600,
            padding: '9px 0',
            borderRadius: 10,
            cursor: 'pointer',
            transition: 'all 0.2s',
          }}
          onMouseEnter={e => e.target.style.borderColor = 'rgba(255,255,255,0.3)'}
          onMouseLeave={e => e.target.style.borderColor = 'rgba(255,255,255,0.12)'}
        >
          Odrzuć
        </button>
        <button
          onClick={accept}
          style={{
            flex: 1,
            background: '#10b981',
            border: 'none',
            color: '#ffffff',
            fontSize: 12,
            fontWeight: 700,
            padding: '9px 0',
            borderRadius: 10,
            cursor: 'pointer',
            transition: 'all 0.2s',
          }}
          onMouseEnter={e => e.target.style.background = '#059669'}
          onMouseLeave={e => e.target.style.background = '#10b981'}
        >
          Akceptuję
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
